import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/DVertResidenceClub.module.styl'
import bg from '~/assets/img/Residence-Club.jpg'
import { useLanguage } from '~/hooks'

export default function DVertResidenceClub() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <h2>
        {t('DVertResidenceClub.title.1')} <br />{' '}
        {t('DVertResidenceClub.title.2')}
      </h2>
      <Lazyload src={bg} className={st.bg}>
        <h3>{t('DVertResidenceClub.subtitle')}</h3>
      </Lazyload>
    </section>
  )
}
